import React, { useContext, useEffect, useRef, useState } from "react";
import { Icon, Tag } from "antd";
import styles from "./index.module.scss";
import classNames from "classnames";
import { InvigilationCtx } from "../../context";

export default function TabExams() {
    const ref = useRef<HTMLDivElement>(null);
    const [collapse, setCollapse] = useState(true);
    const [overflow, setOverflow] = useState(false);

    const { examList, examId, setExamId } = useContext(InvigilationCtx);

    useEffect(() => {
        if (!ref.current) return;
        setOverflow(ref.current.scrollWidth > ref.current.clientWidth);
    }, [examList.length]);

    return (
        <div className={styles.root}>
            <div className={styles.label}>考核名称</div>

            <div
                ref={ref}
                className={classNames(styles.tabs, {
                    [styles.collapse]: collapse
                })}>
                <Tag.CheckableTag
                    checked={examId === ""}
                    className={styles.tag}
                    onChange={() => setExamId("")}>
                    全部
                </Tag.CheckableTag>

                {examList.map(item => (
                    <Tag.CheckableTag
                        key={item.examId}
                        checked={examId === item.examId}
                        className={styles.tag}
                        onChange={() => setExamId(item.examId)}>
                        {item.examName}
                    </Tag.CheckableTag>
                ))}
            </div>

            {overflow && (
                <div
                    className={styles.extra}
                    onClick={() => setCollapse(!collapse)}>
                    {collapse ? "更多" : "收起"}
                    <Icon type="right" />
                </div>
            )}
        </div>
    );
}
